//import { StatusBar } from 'expo-status-bar';
import React, { useEffect, useState, useRef, Fragment } from "react";
import { StyleSheet, Text, View, FlatList, ActivityIndicator, ScrollView, TouchableOpacity } from 'react-native';
//import Button from 'apsl-react-native-button';
import FlatListSeanceItem from './FlatListSeanceItem';
// g-sheet
import Papa from "papaparse";
// navigation
import { useNavigation, useRoute } from '@react-navigation/native';
// storage
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useAsyncStorage } from '@react-native-async-storage/async-storage';
// REDUX
import { useSelector, useDispatch } from 'react-redux'
//import { savedata } from '../Store/dataStore'


function ProgrammeGid ({route, navigation}) {

// REDUX data
  const dataRedux = useSelector((state) => state.data)
  /*
  const dispatch = useDispatch()
  const saveDataToRedux = data =>
  {
console.log("Programme: saveDataToRedux...");
    dispatch(savedata(data))
//console.log(dataRedux);
  }
*/

// HOOKS
const [programmeData, setProgrammeData] = useState([]);
const [isLoading, setIsLoading] = useState(false);
const [erreurProgrammeGid, setErreurProgrammeGid] = useState(false);
const [loadProgrammeFromAsyncOK, setLoadProgrammeFromAsyncOK] = useState(false);

// ROUTE
//console.log("route: "+route);
//console.log("ProgrammeGid: route params gid = "+route.params.gid);


const writeDataProgrammeToAsyncStorage = async (newValue, gid) => {
console.log("ProgrammeGid writeDataProgrammeToAsyncStorage...");
  try {
    const jsonValue = JSON.stringify(newValue)
    await AsyncStorage.setItem('@storage_key_DATA_'+gid, jsonValue);
console.log("ProgrammeGid writeDataProgrammeToAsyncStorage OK");
  } catch(e) {
    console.log("erreur ProgrammeGid writeDataProgrammeToAsyncStorage:"+e);
  }
};

  // Load Programme
  const loadDataProgrammeFromGSheet = () => {
      setIsLoading(true);
      var publicSpreadsheetUrl = 'https://docs.google.com/spreadsheets/d/e/'+route.params.code+'/pub?gid='+route.params.gid+'&single=true&output=csv';
  console.log("ProgrammeGid loadDataProgrammeFromGSheet, route gid:"+route.params.gid+" / route code:"+route.params.code);
        Papa.parse(publicSpreadsheetUrl, {
        download: true,
        header: true,
        error: function(err, file, inputElem, reason)
          {
  console.log("ProgrammeGid loadDataProgrammeFromGSheet: ERROR PAPA");
            console.warn(err);
            setIsLoading(false);
            setErreurProgrammeGid(true);
          },
        complete: function(results) {
//console.log("papa results:"+results)
          var dataFromGSheet = results.data
          // storage: dans ASYNC avec le GID, dans REDUX sans gid (DATA)
          writeDataProgrammeToAsyncStorage(dataFromGSheet, route.params.gid);
          setProgrammeData(dataFromGSheet);
          // MAJ interface
          setIsLoading(false);
          setErreurProgrammeGid(false);
        }
      });
  };


  useEffect( () => {
    const readDataProgrammeFromAsyncStorage = async () => {
      try {
        const jsonValue = await AsyncStorage.getItem('@storage_key_DATA_'+route.params.gid)
        const parsedData = jsonValue != null ? JSON.parse(jsonValue) : null;
        if (parsedData !== null) {
          setLoadProgrammeFromAsyncOK(true);
          // save data de Async Storage dans programmeData (local)
          setProgrammeData(parsedData);
console.log("ProgrammeGid useFX: readDataProgrammeFromAsyncStorage OK:"+parsedData);
        }
        else {
console.log("ProgrammeGid useFX: no AsyncStorage -> loadDataProgrammeFromGSheet...");
          setLoadProgrammeFromAsyncOK(false);
          loadDataProgrammeFromGSheet();
        }
      } catch(e) {
console.log("ProgrammeGid useFX: readDataProgrammeFromAsyncStorage ERREUR: "+e);
        setLoadProgrammeFromAsyncOK(false)
console.log("ProgrammeGid useFX: no AsyncStorage -> loadDataProgrammeFromGSheet...");
        loadDataProgrammeFromGSheet();
      }
    }
console.log("ProgrammeGid useFX: readDataProgrammeFromAsyncStorage ONCE au lancement...");
    readDataProgrammeFromAsyncStorage();
console.log("ProgrammeGid useFX: readDataFromAsyncStorage DONE");
  }, []); // FIRST rendering ONLY
//}, [navigation]); // FIRST rendering + si navigation change
//}); // EVERY rendering


  return (
    <View style={{flex: 1}}>

    { (isLoading) ?
      <View style={{flex: 1}}>
        <ActivityIndicator size="large" color="#0000ff" />
      </View>
      :
      <View style={{flex: 10}}>
        <FlatList
          data={programmeData}
          keyExtractor={(item) => item.id} //.toString()
          renderItem={({item}) =>
          <FlatListSeanceItem seance={item} couleur={route.params.couleur}/>
        }
        />
      </View>
    }

    </View>

  );

};


const styles = StyleSheet.create({
  container: {
    marginTop: 30,
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
});



export default ProgrammeGid
